import { createReducer } from '@reduxjs/toolkit'

import { userLogout } from '@/redux/auth/actions'
import {
  addPatientFailed,
  addPatientRequest,
  addPatientSuccess,
  getPatientRequest,
  getPatientsFailed,
  getPatientsRequest,
  getPatientsSuccess,
  getPatientSuccess,
  renewProgramFailed,
  renewProgramRequest,
  renewProgramSuccess,
  resetPatients,
  stopManagePatientFailed,
  stopManagePatientRequest,
  stopManagePatientSuccess
} from './actions'
import { PatientsModel } from './types'

interface IGetPatientsState {
  loading: boolean
  patientsData: PatientsModel[]
}

const initialState: IGetPatientsState = {
  loading: false,
  patientsData: []
}

interface IAddPatientsState {
  loading: boolean
}

const initialStateAddPatient: IAddPatientsState = {
  loading: false
}

interface IRenewProgramState {
  loading: boolean
}

const initialStateRenewProgram: IRenewProgramState = {
  loading: false
}

const patientsReducer = createReducer(initialState, builder => {
  builder
    .addCase(getPatientsRequest, state => {
      state.loading = true
    })
    .addCase(getPatientRequest, state => {
      state.loading = true
    })
    .addCase(getPatientsSuccess, (state, action) => {
      state.loading = false
      state.patientsData = action.payload.patientsData
    })
    .addCase(getPatientSuccess, (state, action) => {
      state.loading = false

      if (
        state.patientsData.some(
          patient => patient.id === action.payload.patientData.id
        )
      ) {
        state.patientsData = state.patientsData.map(patient =>
          patient.id === action.payload.patientData.id
            ? action.payload.patientData
            : patient
        )
      } else {
        state.patientsData = [...state.patientsData, action.payload.patientData]
      }
    })
    .addCase(getPatientsFailed, state => {
      state.loading = false
      state.patientsData = []
    })
    .addCase(stopManagePatientRequest, state => {
      state.loading = true
    })
    .addCase(stopManagePatientSuccess, (state, action) => {
      state.loading = false
      state.patientsData = state.patientsData.filter(
        patient => patient.id !== action.payload.patientId
      )
    })
    .addCase(stopManagePatientFailed, state => {
      state.loading = false
    })
    .addCase(userLogout, state => {
      state.loading = false
      state.patientsData = []
    })
    .addCase(resetPatients, state => {
      state.loading = false
      state.patientsData = []
    })
})

const addPatientReducer = createReducer(initialStateAddPatient, builder => {
  builder
    .addCase(addPatientRequest, state => {
      state.loading = true
    })
    .addCase(addPatientSuccess, state => {
      state.loading = false
    })
    .addCase(addPatientFailed, state => {
      state.loading = false
    })
})

const renewProgramReducer = createReducer(initialStateRenewProgram, builder => {
  builder
    .addCase(renewProgramRequest, state => {
      state.loading = true
    })
    .addCase(renewProgramSuccess, state => {
      state.loading = false
    })
    .addCase(renewProgramFailed, state => {
      state.loading = false
    })
})

export { addPatientReducer, patientsReducer, renewProgramReducer }
